import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { goto } from '../../../../actions/historyActions';
import { changeCurUpdateKey } from '../../actions/customerResetUNOrPWAction';
import EmmaNavTitle from '../../../../components/EmmaNavTitle';
import {
  resolveLocalizedText,
  resolvePublicAssets,
  getLoginId,
  hideBackButton,
  isApp,
} from '../../../../utils';
import CustomerProfileTitle from '../../components/CustomerProfileTitle';
import {
  getCustomerProfileResetPasswordConfig,
  getCustomerProfileResetUsenameConfig,
  getCustomerProfileResetUsenameOrPasswordConfig,
} from '../../selectors/customerProfileResetUNOrPWSelectors';
import { customerResetUNOrPWService } from '../../types/customerSettingFeaturesService';
import {
  RESET_USER_NAME_KEY,
  RESET_PASSWORD_KEY,
} from '../../constants/constants';
import { getToken } from '../../../../selectors/authSelectors';
import { select } from '../../../../stores';
import './style.scss';

export interface CustomerResetUNOrPWContainerProps {
  title: string;
  desc: string;
  resetUsename: any;
  resetPassword: any;
  onChangeCurUpdateKey: (params?: any) => void;
}

export interface CustomerResetUNOrPWContainerState {}

export class CustomerResetUNOrPWContainer extends Component<
  CustomerResetUNOrPWContainerProps,
  CustomerResetUNOrPWContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    isApp() && hideBackButton();
  }

  render() {
    const { title, desc, resetUsename, resetPassword, onChangeCurUpdateKey } =
      this.props;
    const token = select(getToken);
    const loginId = getLoginId(token);
    const resetUseNamePWData = [
      {
        key: RESET_USER_NAME_KEY,
        label:
          resetUsename && resetUsename.label
            ? resolveLocalizedText(resetUsename.label)
            : '',
        value: loginId,
        deepLink: _.get(resetUsename, `deepLink.query.url`, ''),
      },
      {
        key: RESET_PASSWORD_KEY,
        label:
          resetPassword && resetPassword.label
            ? resolveLocalizedText(resetPassword.label)
            : '',
        value: '********',
        deepLink: _.get(resetPassword, `deepLink.query.url`, ''),
      },
    ];
    const iconPath = 'assets/images/customer-profile/right-arrow.png';
    return (
      <div className="customer-reset-usename-or-password-container">
        <div className="emma-stylesheet-grid-system">
          <EmmaNavTitle
            title={title}
            component={<CustomerProfileTitle customerTitle={title} />}
          />
          <div className="customer-reset-usename-or-password-container-desc">
            {desc}
          </div>
          <div className="customer-reset-usename-or-password-container-ul col-12 col-lg-6">
            {resetUseNamePWData.map((item: customerResetUNOrPWService) => {
              return (
                <div
                  data-enable-ga
                  data-ga-type="button"
                  data-ga-text={item.label}
                  className="customer-reset-usename-or-password-container-ul-li content-align-right"
                  onClick={() => {
                    goto(item.deepLink);
                    onChangeCurUpdateKey(item.key);
                  }}
                >
                  <div className="customer-reset-usename-or-password-container-ul-li-left">
                    {item.label}
                  </div>
                  <div className="customer-reset-usename-or-password-container-ul-li-right content-align-right">
                    <div className="customer-reset-usename-or-password-container-ul-li-right-span">
                      {item.value}
                    </div>
                    <div className="customer-reset-usename-or-password-container-ul-li-right-icon">
                      <img src={resolvePublicAssets(iconPath)} alt="" />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const resetUsenameOrPasswordLabels =
      getCustomerProfileResetUsenameOrPasswordConfig(state);
    const title =
      resetUsenameOrPasswordLabels && resetUsenameOrPasswordLabels.title
        ? resolveLocalizedText(resetUsenameOrPasswordLabels.title)
        : '';
    const desc =
      resetUsenameOrPasswordLabels && resetUsenameOrPasswordLabels.desc
        ? resolveLocalizedText(resetUsenameOrPasswordLabels.desc)
        : '';
    const resetUsename = getCustomerProfileResetUsenameConfig(state);
    const resetPassword = getCustomerProfileResetPasswordConfig(state);
    return {
      title,
      desc,
      resetUsename,
      resetPassword,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onChangeCurUpdateKey: (params: any) =>
        dispatch(changeCurUpdateKey(params)),
    };
  }
}

export default connect(
  CustomerResetUNOrPWContainer.mapStateToProps,
  CustomerResetUNOrPWContainer.mapDispatchToProps,
)(CustomerResetUNOrPWContainer);
